/* Schmunzelgeschenk – Produktkarten (Inhaber 22.10.): Farbfeld überfahren oder fokussieren → das Kartenbild zeigt diese Variante
   (Überlagerung im Bildkasten, gleiche Ecken); verlassen → wieder das Kartenbild. Felder: snippets/sg-karte-optionen.liquid. */
(function () {
  'use strict';
  function kasten(f) {
    var k = f.closest('product-card, .sg-pk'); if (!k) return null;
    return k.querySelector('.card-gallery') || k.querySelector('.sg-pk-bild');
  }
  function zeigen(f) {
    var url = f.getAttribute('data-bild'), box = kasten(f); if (!box) return;
    var zeile = f.closest('.sg-ko'); if (zeile) zeile.querySelectorAll('.sg-ko-f').forEach(function (x) { x.classList.toggle('sg-ko-f--an', x === f); });
    if (!url) return;
    var ov = box.querySelector('.sg-ko-vorschau');
    if (!ov) { ov = document.createElement('img'); ov.className = 'sg-ko-vorschau'; ov.alt = ''; ov.setAttribute('aria-hidden', 'true'); ov.decoding = 'async'; box.appendChild(ov); }
    if (ov.getAttribute('src') !== url) ov.src = url;
    ov.hidden = false;
  }
  function weg(f) {
    var box = kasten(f), ov = box && box.querySelector('.sg-ko-vorschau'); if (ov) ov.hidden = true;
    f.classList.remove('sg-ko-f--an');
  }
  function feld(e) { return e.target && e.target.closest ? e.target.closest('.sg-ko-f') : null; }
  document.addEventListener('pointerover', function (e) { var f = feld(e); if (f && e.pointerType !== 'touch') zeigen(f); });
  document.addEventListener('pointerout', function (e) { var f = feld(e); if (f && !(e.relatedTarget && f.contains(e.relatedTarget))) weg(f); });
  document.addEventListener('focusin', function (e) { var f = feld(e); if (f) zeigen(f); });
  document.addEventListener('focusout', function (e) { var f = feld(e); if (f) weg(f); });
})();
/* „Weiterlesen“ (Seitentext der Anlass-Seiten): Inhalt bleibt im DOM (hidden="until-found" – Suche im Browser öffnet ihn ebenfalls) */
(function () {
  'use strict';
  function setzen(knopf, offen) {
    var r = document.getElementById(knopf.getAttribute('data-sg-weiter')); if (!r) return;
    if (offen) r.removeAttribute('hidden'); else r.setAttribute('hidden', 'until-found');
    knopf.setAttribute('aria-expanded', String(offen)); knopf.textContent = offen ? 'Weniger anzeigen' : 'Weiterlesen';
    var k = knopf.closest('.sg-text-karte'); if (k) k.classList.toggle('sg-st-zu', !offen);
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-sg-weiter]'); if (!b) return;
    var offen = b.getAttribute('aria-expanded') !== 'true'; setzen(b, offen);
    if (!offen) { var k = b.closest('.sg-text-karte'), r = k && k.getBoundingClientRect(); if (r && r.top < 0) k.scrollIntoView({ block: 'start', behavior: 'smooth' }); }
  });
  document.addEventListener('beforematch', function (e) {
    var r = e.target; if (!r || !r.id) return; var b = document.querySelector('[data-sg-weiter="' + r.id + '"]'); if (b) setzen(b, true);
  }, true);
})();
